import {get,put} from '@/api/request.js'

/**
 * 获取difySwitch开关状态
 * 
 */
export const get_difySwitch = async function () {
    return await get('/knowledge')
}

/**
 * 更新difySwitch开关状态
 * @param data
 */
export const update_difySwitch = async function (data) {
    return await put('/knowledge',{
        data: data
    })
}